import * as actionTypes from "./actionTypes";
import initialState from "./initialState"

import { failureFunc, initialFunc, receiveFunc, requestFunc } from "./operation"

const reducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case actionTypes.USER_REQUEST:
      return requestFunc(state, action)
    case actionTypes.USER_RECEIVE:
      return receiveFunc(state, action)
    case actionTypes.USER_FAILURE:
      return failureFunc(state, action)
    case actionTypes.USER_INITIAL:
      return initialFunc(state, action)
    default:
      return state
  }
}

export default reducer;